import styled from 'styled-components';
export const Container = styled.canvas `
  display: block;
  user-select: none;
`;
